import React from "react";

const AUTH_KEYS = ["token", "refreshToken", "user", "doctor", "userRut", "tutorial"];

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] App crash detectado:", error, info?.componentStack);
    AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
    window.location.href = "/iniciar-sesion";
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
